module.exports = __webpack_public_path__ + "static/media/screenshot4.a5e15ad7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/screenshot4.jpeg
// module id = 290
// module chunks = 0